<div class="modal-header">
  <h4 class="modal-title">{{ "Export measurement coordinates" | translate }}</h4>
  <button [attr.aria-label]="'Close' | translate" (click)="close()" class="btn-close" type="button"></button>
</div>
<div class="modal-body">
  <!-- Format selector buttons -->
  <div class="format-selector mb-3">
    <div class="form-group">
      <label>{{ "Coordinate Format" | translate }}</label>
      <div class="btn-group" role="group">
        <button
          [attr.aria-label]="'Sexagesimal format' | translate"
          [class.btn-outline-primary]="selectedFormat !== formats.SEXAGESIMAL"
          [class.btn-primary]="selectedFormat === formats.SEXAGESIMAL"
          (click)="changeFormat(formats.SEXAGESIMAL)"
          class="btn"
          type="button"
        >
          {{ "Sexagesimal" | translate }}
        </button>
        <button
          [attr.aria-label]="'Decimal format' | translate"
          [class.btn-outline-primary]="selectedFormat !== formats.DECIMAL"
          [class.btn-primary]="selectedFormat === formats.DECIMAL"
          (click)="changeFormat(formats.DECIMAL)"
          class="btn"
          type="button"
        >
          {{ "Decimal" | translate }}
        </button>
        <button
          [attr.aria-label]="'HMS/DMS format' | translate"
          [class.btn-outline-primary]="selectedFormat !== formats.HMS_DMS"
          [class.btn-primary]="selectedFormat === formats.HMS_DMS"
          (click)="changeFormat(formats.HMS_DMS)"
          class="btn"
          type="button"
        >
          {{ "HMS/DMS" | translate }}
        </button>
      </div>
    </div>
  </div>

  <!-- Center coordinates -->
  <div *ngIf="hasContent(formattedData.centerCoordinates)" class="coordinate-group mb-3">
    <label>{{ "Center Coordinates" | translate }}</label>
    <div class="input-group">
      <input
        [attr.aria-label]="'Center coordinates' | translate"
        [value]="formattedData.centerCoordinates"
        class="form-control"
        readonly
        type="text"
      />
      <button
        [title]="copiedField === 'center' ? ('Copied!' | translate) : ('Copy to clipboard' | translate)"
        (click)="copyToClipboard(formattedData.centerCoordinates, 'center')"
        class="btn btn-outline-primary"
        type="button"
      >
        <fa-icon [icon]="copiedField === 'center' ? 'check' : 'copy'" class="mr-0"></fa-icon>
      </button>
    </div>
  </div>

  <!-- Rectangle corner coordinates -->
  <div
    *ngIf="
      formattedData.corners &&
      (hasContent(formattedData.corners.topLeft) ||
        hasContent(formattedData.corners.topRight) ||
        hasContent(formattedData.corners.bottomLeft) ||
        hasContent(formattedData.corners.bottomRight))
    "
    class="rectangle-corners"
  >
    <h5>{{ "Rectangle Corners" | translate }}</h5>

    <!-- Top Left -->
    <div *ngIf="hasContent(formattedData.corners.topLeft)" class="coordinate-group mb-3">
      <label>{{ "Top Left" | translate }}</label>
      <div class="input-group">
        <input
          [attr.aria-label]="'Top left corner coordinates' | translate"
          [value]="formattedData.corners.topLeft"
          class="form-control"
          readonly
          type="text"
        />
        <button
          [title]="copiedField === 'topLeft' ? ('Copied!' | translate) : ('Copy to clipboard' | translate)"
          (click)="copyToClipboard(formattedData.corners.topLeft, 'topLeft')"
          class="btn btn-outline-primary"
          type="button"
        >
          <fa-icon [icon]="copiedField === 'topLeft' ? 'check' : 'copy'" class="mr-0"></fa-icon>
        </button>
      </div>
    </div>

    <!-- Top Right -->
    <div *ngIf="hasContent(formattedData.corners.topRight)" class="coordinate-group mb-3">
      <label>{{ "Top Right" | translate }}</label>
      <div class="input-group">
        <input
          [attr.aria-label]="'Top right corner coordinates' | translate"
          [value]="formattedData.corners.topRight"
          class="form-control"
          readonly
          type="text"
        />
        <button
          [title]="copiedField === 'topRight' ? ('Copied!' | translate) : ('Copy to clipboard' | translate)"
          (click)="copyToClipboard(formattedData.corners.topRight, 'topRight')"
          class="btn btn-outline-primary"
          type="button"
        >
          <fa-icon [icon]="copiedField === 'topRight' ? 'check' : 'copy'" class="mr-0"></fa-icon>
        </button>
      </div>
    </div>

    <!-- Bottom Left -->
    <div *ngIf="hasContent(formattedData.corners.bottomLeft)" class="coordinate-group mb-3">
      <label>{{ "Bottom Left" | translate }}</label>
      <div class="input-group">
        <input
          [attr.aria-label]="'Bottom left corner coordinates' | translate"
          [value]="formattedData.corners.bottomLeft"
          class="form-control"
          readonly
          type="text"
        />
        <button
          [title]="copiedField === 'bottomLeft' ? ('Copied!' | translate) : ('Copy to clipboard' | translate)"
          (click)="copyToClipboard(formattedData.corners.bottomLeft, 'bottomLeft')"
          class="btn btn-outline-primary"
          type="button"
        >
          <fa-icon [icon]="copiedField === 'bottomLeft' ? 'check' : 'copy'" class="mr-0"></fa-icon>
        </button>
      </div>
    </div>

    <!-- Bottom Right -->
    <div *ngIf="hasContent(formattedData.corners.bottomRight)" class="coordinate-group mb-3">
      <label>{{ "Bottom Right" | translate }}</label>
      <div class="input-group">
        <input
          [attr.aria-label]="'Bottom right corner coordinates' | translate"
          [value]="formattedData.corners.bottomRight"
          class="form-control"
          readonly
          type="text"
        />
        <button
          [title]="copiedField === 'bottomRight' ? ('Copied!' | translate) : ('Copy to clipboard' | translate)"
          (click)="copyToClipboard(formattedData.corners.bottomRight, 'bottomRight')"
          class="btn btn-outline-primary"
          type="button"
        >
          <fa-icon [icon]="copiedField === 'bottomRight' ? 'check' : 'copy'" class="mr-0"></fa-icon>
        </button>
      </div>
    </div>
  </div>

  <div class="info-text">
    <small>
      {{
        "These coordinates represent the celestial coordinates of your measurement. You can copy individual values or change the format using the buttons above."
          | translate
      }}
    </small>
  </div>
</div>
<div class="modal-footer">
  <button (click)="close()" class="btn btn-secondary" type="button">
    {{ "Close" | translate }}
  </button>
</div>
